import { put } from "redux-saga/effects";

import { ApiCaller } from "../../config";
import { ChatbotAction } from "../actions";

export default class ChatbotMiddleware {
  static *addMessage({ payload, cb }) {
    try {
      const res = yield ApiCaller.Post(`/chatbot/addMessage`, payload);
      if (res.status === 200) {
        yield put(ChatbotAction.addMessageSuccess(res.data.data));
      } else {
        yield put(ChatbotAction.addMessageFailure());
      }
      if (cb) {
        cb(res.data.data);
      }
    } catch (err) {
      yield put(ChatbotAction.addMessageFailure());
    }
  }

  static *getMessages({ payload, cb }) {
    try {
      const res = yield ApiCaller.Get(
        `/chatbot/getMessages?from=${payload.from}&to=${payload.to}`
      );
      if (res.status === 200) {
        yield put(ChatbotAction.getMessagesSuccess(res.data.data));
      } else {
        yield put(ChatbotAction.getMessagesFailure());
      }
      if (cb) {
        cb(res.data);
      }
    } catch (err) {
      yield put(ChatbotAction.getMessagesFailure());
    }
  }
  static *getUnreadMessages({ payload, cb }) {
    try {
      const res = yield ApiCaller.Get(
        `/chatbot/getUnreadMessages?from=${payload.from}`
      );
      if (res.status === 200) {
        yield put(ChatbotAction.getUnreadMessagesSuccess(res.data.data));
      } else {
        yield put(ChatbotAction.getUnreadMessagesFailure());
      }
      if (cb) {
        cb(res.data.data);
      }
    } catch (err) {
      yield put(ChatbotAction.getUnreadMessagesFailure());
    }
  }
  static *getUsers({ payload, cb }) {
    try {
      const res = yield ApiCaller.Get(
        `/chatbot/getStudentsAndSupport?schoolId=${payload.schoolId}`
      );
      if (res.status === 200) {
        yield put(ChatbotAction.getUsersSuccess(res.data.data));
      } else {
        yield put(ChatbotAction.getUsersFailure());
      }
      if (cb) {
        cb(res.data);
      }
    } catch (err) {
      yield put(ChatbotAction.getUsersFailure());
    }
  }
}
